import formatValue from "../utils/formatValue";
import {
  commissionFormFromApi,
  formatCommissionSummary,
  parseCommissionEstimate,
} from "../utils/propertyCommission";

type Props = {
  property: Record<string, unknown>;
};

export default function PropertyCommissionSummary({ property }: Props) {
  const form = commissionFormFromApi(property);
  const estimate = parseCommissionEstimate(property.commission_estimate);

  return (
    <section className="rounded-2xl border border-[#e2e2e2] bg-gradient-to-b from-white to-[#fafafa] p-6 shadow-[0_6px_22px_rgba(0,0,0,0.055)]">
      <h2 className="mb-5 text-xl font-bold text-[#2d2d2d]">Comissões e ADM</h2>
      <p className="break-words text-[15px] leading-6 text-[#2d2d2d]">
        {formatCommissionSummary(form)}
      </p>
      {estimate ? (
        <dl className="mt-4 grid grid-cols-1 gap-3 text-sm text-[#2d2d2d] md:grid-cols-3">
          {estimate.monthlyAdmin != null ? (
            <div>
              <dt className="text-xs font-medium uppercase tracking-wide text-slate-500">
                ADM mensal
              </dt>
              <dd className="mt-0.5 font-semibold">
                {formatValue(estimate.monthlyAdmin)}
              </dd>
            </div>
          ) : null}
          {estimate.firstRentCommission != null ? (
            <div>
              <dt className="text-xs font-medium uppercase tracking-wide text-slate-500">
                1º aluguel
              </dt>
              <dd className="mt-0.5 font-semibold">
                {formatValue(estimate.firstRentCommission)}
              </dd>
            </div>
          ) : null}
          {estimate.firstMonthTotal != null ? (
            <div>
              <dt className="text-xs font-medium uppercase tracking-wide text-slate-500">
                Primeiro mês
              </dt>
              <dd className="mt-0.5 font-semibold">
                {formatValue(estimate.firstMonthTotal)}
              </dd>
            </div>
          ) : null}
        </dl>
      ) : null}
    </section>
  );
}
